// Copyright (c) 2018 Deere & Company

import {getPipProductSearchColumns} from './pip-product-search-excel-columns';
import {getPipSearchColumns} from './pip-search-excel-columns';

export const getExcelLayoutListColumns = searchByType =>
    searchByType === 'PIN' ?
        getPipProductSearchColumns().listColumns :
        getPipSearchColumns().listColumns;



// WEBPACK FOOTER //
// ./src/pip/pip-search/services/get-excel-layout-list-columns.js